import { render, staticRenderFns } from "./Noticelist.vue?vue&type=template&id=493ff6ed&scoped=true&"
import script from "./Noticelist.vue?vue&type=script&lang=js&"
export * from "./Noticelist.vue?vue&type=script&lang=js&"
import style0 from "./Noticelist.vue?vue&type=style&index=0&id=493ff6ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493ff6ed",
  null
  
)

export default component.exports